<template>
  <div class="full-reduction-pop">
    <van-popup
      v-model="show"
      position="bottom"
      round
      safe-area-inset-bottom
      :close-on-popstate="true"
      :style="{ 'min-height': '30%', 'max-height': '62%', 'overflow': 'auto', background: '#F7F8FC' }"
      @close="onClose"
      closeable
      close-icon="cross"
    >
      <div class="titleName">赠品</div>
      <div class="content">
        <!-- 会员  -->
        <template v-if="giftMemberList">
          <GoodsCard member="true" v-for="(item, index) in giftMemberList" :key="index" :goodsInfo="item" />
        </template>
        <!-- 实物 -->
        <template v-if="giftMaterialList">
          <GoodsCard v-for="(item, index) in giftMaterialList" :key="index" :goodsInfo="item" />
        </template>
        <!-- 优惠券 -->
        <template v-if="wholeGiftlist">
          <NewCouponCard v-for="(item, index) in wholeGiftlist" :key="index" :goodsInfo="item" />
        </template>
      </div>
    </van-popup>
  </div>
</template>

<script>
import GoodsCard from '@/pages/payment/couponPop/goodsCard.vue';
import NewCouponCard from '@/pages/payment/couponPop/newCouponCard.vue';

export default {
  components: { GoodsCard, NewCouponCard },
  props: {
    giftMaterialList: {
      type: Array,
      default: () => [],
    },
    wholeGiftlist: {
      type: Array,
      default: () => [],
    },
    giftMemberList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: true,
    };
  },
  mounted() {},
  methods: {
    onClose() {
      this.$emit('giveGiftsClose');
    },
  },
};
</script>
<style scoped lang="scss">
.full-reduction-pop {
  .titleName {
    margin-top: 25px;
    color: #333;
    font-weight: 600;
    font-size: 33px;
    line-height: 45px;
    text-align: center;
  }
  .content {
    height: calc(100% - 100px);
    padding: 60px 36px;
  }
}
::v-deep .van-icon-cross::before {
  color: #999;
}
// ::v-deep .goodItemCompont {
//   box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
// }
</style>
